// extracted by mini-css-extract-plugin
export default {"button":"CatalogNumbers_button__scw9l","table":"CatalogNumbers_table__oEQoJ","title":"CatalogNumbers_title__OQQAG"};